import { useCurrentModule } from '../components/ModuleProvider';
import { useIsSeasonalSale } from './useIsSeasonalSale';
const splitTime = time => {
  return {
    days: Math.floor(time / (1000 * 60 * 60 * 24)),
    hours: Math.floor(time / (1000 * 60 * 60) % 24),
    minutes: Math.floor(time / (1000 * 60) % 60),
    seconds: Math.floor(time / 1000 % 60)
  };
};
export const useSaleBannerType = () => {
  var _discountData$discoun, _discountData$discoun2;
  const module = useCurrentModule();
  const isSeasonalSale = useIsSeasonalSale();
  const {
    data: discountData,
    isLoading: isDiscountLoading
  } = module.SDK.studioOfferingApiClient.hooks.useFetchOfferingDiscount({});
  const expiresAt = discountData == null || (_discountData$discoun = discountData.discount) == null ? void 0 : _discountData$discoun.expiresAt;
  const rate = discountData == null || (_discountData$discoun2 = discountData.discount) == null ? void 0 : _discountData$discoun2.rate;
  if (!isSeasonalSale || isDiscountLoading || !rate) {
    return {
      bannerType: null,
      isLoading: isDiscountLoading
    };
  }
  const timeLeft = expiresAt ? new Date(expiresAt).getTime() - new Date().getTime() : null;
  const isLastDay = timeLeft != null && splitTime(timeLeft).days === 0;
  return {
    bannerType: isLastDay ? 'last_day' : 'seasonal_regular',
    isLoading: false
  };
};
//# sourceMappingURL=useSaleBannerType.js.map